import { inject, Injectable } from '@angular/core';
import { BaseApi } from './base/base-api';
import { environment } from '../../../environments/environment';
import { AuditLogQuery } from '../../../shared/models/audit/audit-log-query';
import { map, Observable } from 'rxjs';
import { Pagination } from '../../../shared/models/internal/pagination';
import { AuditLog } from '../../../shared/models/audit/audit-log';
import { TranslationService } from '../translation.service';

@Injectable({
  providedIn: 'root',
})
export class AuditLogApiService extends BaseApi {
  private readonly translationService = inject(TranslationService);

  constructor() {
    const url = environment.api + 'auditlog';
    super(url);
  }

  public getAuditLogs(query: AuditLogQuery): Observable<Pagination<AuditLog>> {
    const queryParams: Record<string, string> = {
      entityId: query.entityId ?? '',
      parentEntityId: query.parentEntityId ?? '',
      parentEndingAt: query.parentEndingAt ? query.parentEndingAt?.toString() || '' : '',
    };

    if (query.page !== undefined) {
      queryParams['page'] = query.page.toString();
    }

    if (query.pageSize !== undefined) {
      queryParams['pageSize'] = query.pageSize.toString();
    }

    return this.http
      .get<AuditLog[]>(this.baseUrl + '?' + new URLSearchParams(queryParams).toString(), {
        observe: 'response',
      })
      .pipe(
        map((response) => {
          const auditLogs = this.translationService.processAuditLogsForCurrentLanguage(response.body ?? []);
          const paginationHeader = response.headers.get(this.xPaginationHeader);

          if (paginationHeader) {
            const pagination = JSON.parse(paginationHeader) as Pagination<AuditLog>;
            pagination.items = auditLogs;
            return pagination;
          }
          throw new Error('Pagination header not found');
        })
      );
  }
}
